import { render } from "./MembresiaList.vue?vue&type=template&id=acb25bee&scoped=true"
import script from "./MembresiaList.vue?vue&type=script&lang=js"
export * from "./MembresiaList.vue?vue&type=script&lang=js"

import "./MembresiaList.vue?vue&type=style&index=0&id=acb25bee&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb25bee"]])

export default __exports__